var ButtonHandler = /** @class */ (function () {
    function ButtonHandler(_a) {
        var _this = this;
        var action = _a.action, setLoading = _a.setLoading, setDisabled = _a.setDisabled;
        this._handleStatus = function (isValidating) {
            if (_this.action === "submit") {
                _this.setLoading(isValidating);
            }
            else {
                _this.setDisabled(isValidating);
            }
        };
        this._setDisabledByForm = function (disabled) {
            _this.setDisabled(disabled);
        };
        this.action = action;
        this.setLoading = setLoading;
        this.setDisabled = setDisabled;
    }
    return ButtonHandler;
}());
export { ButtonHandler };
